import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { CommonService } from '@app/components/_common/common.service';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.states';

import { annotatorsLoad } from './annotators.actions';
import { getAllAnnotators } from '@app/components/projects/surveys/annotation/store/annotators.selector';

@Injectable()
export class AnnotatorsEffects {
  constructor(private store: Store<AppState>, private actions$: Actions, private commonService: CommonService) {}

  GetAnnotatorList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(annotatorsLoad),
      map((action) => action),
      withLatestFrom(this.store.select(getAllAnnotators)),
      map((state) => state),
      switchMap(([payload, state]) => {
        const forceRefresh = payload.forceRefresh || false;

        if (state.annotators.length > 0 && !forceRefresh) {
          return EMPTY;
        } else {
          return this.commonService.getAnnotatorsList().pipe(
            map((list) => ({ type: '[annotators] Load Success', list: list.data.datas.rows })),
            catchError(() => EMPTY)
          );
        }
      })
    )
  );
}
